var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgThanksPageCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 206.858,
    height: 194.598,
    viewBox: "0 0 206.858 194.598",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.313,
    y1: 0.964,
    x2: 0.684,
    y2: 0.045,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#93d900"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#009fda"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Mask",
    x: 6.291,
    y: 0,
    width: 200.567,
    height: 194.598,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 6,
    dy: 6,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 11,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.251
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Path_555",
    x: 50.454,
    y: 33.644,
    width: 125.743,
    height: 105.756,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 6,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6,
    result: "blur-2"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-2"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1787",
    "data-name": "Group 1787",
    transform: "translate(-13561.637 -145.667)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1786",
    "data-name": "Group 1786",
    transform: "translate(12458.281 482.405)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "sparkle",
    transform: "matrix(0.309, -0.951, 0.951, 0.309, 1082.607, -196.165)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval_3_Copy_5",
    "data-name": "Oval 3 Copy 5",
    cx: 2.85,
    cy: 2.744,
    rx: 2.85,
    ry: 2.744,
    transform: "translate(67.142 0)",
    fill: "#36B22D"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval_3_Copy_7",
    "data-name": "Oval 3 Copy 7",
    cx: 7.379,
    cy: 7.104,
    rx: 7.379,
    ry: 7.104,
    transform: "translate(135.551 53.348)",
    fill: "#36B22D"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval_3_Copy_8",
    "data-name": "Oval 3 Copy 8",
    cx: 5.186,
    cy: 4.993,
    rx: 5.186,
    ry: 4.993,
    transform: "translate(158.354 150.186)",
    fill: "#36B22D"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval_3_Copy_13",
    "data-name": "Oval 3 Copy 13",
    cx: 2.63,
    cy: 2.532,
    rx: 2.63,
    ry: 2.532,
    transform: "translate(165.955 95.121)",
    fill: "#36B22D"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval_3_Copy_14",
    "data-name": "Oval 3 Copy 14",
    cx: 1.644,
    cy: 1.582,
    rx: 1.644,
    ry: 1.582,
    transform: "translate(156.454 119.172)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval_3_Copy_15",
    "data-name": "Oval 3 Copy 15",
    cx: 1.315,
    cy: 1.266,
    rx: 1.315,
    ry: 1.266,
    transform: "translate(83.611 157.781)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval_3_Copy_16",
    "data-name": "Oval 3 Copy 16",
    cx: 1.315,
    cy: 1.266,
    rx: 1.315,
    ry: 1.266,
    transform: "translate(106.414 133.097)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval_3_Copy_9",
    "data-name": "Oval 3 Copy 9",
    cx: 3.484,
    cy: 3.354,
    rx: 3.484,
    ry: 3.354,
    transform: "translate(145.052 43.221)",
    fill: "#36B22D"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval_3_Copy_11",
    "data-name": "Oval 3 Copy 11",
    cx: 1.267,
    cy: 1.22,
    rx: 1.267,
    ry: 1.22,
    transform: "translate(0 43.221)",
    fill: "#36B22D"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval_3_Copy_12",
    "data-name": "Oval 3 Copy 12",
    cx: 2.217,
    cy: 2.134,
    rx: 2.217,
    ry: 2.134,
    transform: "translate(15.202 140.761)",
    fill: "#36B22D"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval_3_Copy_10",
    "data-name": "Oval 3 Copy 10",
    cx: 1.644,
    cy: 1.582,
    rx: 1.644,
    ry: 1.582,
    transform: "translate(144.992 3.219)",
    fill: "#36B22D"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 13561.64, 145.67)",
    filter: "url(#Mask)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Mask-2",
    "data-name": "Mask",
    d: "M132.466,98.642c11.56-32.292-27.034-80.986-55.646-94.033S15.643,7.163,4.083,39.456,6.347,108.5,34.958,121.55s85.948,9.384,97.507-22.908",
    transform: "translate(33.29 27)",
    fill: "#36B22D"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 13561.64, 145.67)",
    filter: "url(#Path_555)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_555-2",
    "data-name": "Path 555",
    d: "M406-414.651l20.489,20.489s38.315-38.787,48.041-48.513",
    transform: "translate(-328.94 498.92)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "square",
    strokeWidth: 15
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThanksPageCheck);
export default __webpack_public_path__ + "static/media/thanks-page-check.0dc6a43020544e77ed6522847677e6f7.svg";
export { ForwardRef as ReactComponent };